import * as React from 'react';
import {
    Box,
    Drawer,
    CssBaseline,
    Toolbar,
    Typography,
    Divider,
    useTheme,
    AppBar,
    Paper,
    IconButton,
} from "@mui/material";
import Grid from "@material-ui/core/Grid";
import SideBar from './Sidebar';
import { LEFT_MENU_WIDTH, PaymentPages } from './Utils';
import { getBaseConfig, isIpad, isSocialMobileApp } from '../../../Utils';
import { setAvatarPop } from '../../../redux/tool-webjam/actions';
import { SETTINGS_TABS, SettingsButton } from "../../../../settings";
import Avatar from "../../components/Avatar";
import { useDispatch, useSelector } from 'react-redux';
import { setLeftMenuStatus, setPaymentSelectedPage } from './payment-reducer/actions';
import { styled } from '@mui/material/styles';
import NavBars from './helperComponent/NavBars';
import { FEATURE_CUSTOM_PAYMENT } from '../../../constant';
import { isMobileBrowser, useDevice } from '../../Utils';
import { LanguageSelect } from '../LanguageSelect';

const drawerWidth = LEFT_MENU_WIDTH;

const AppBarMenu = styled(AppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: `${drawerWidth}px`,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
}));

let welcomeCss = document.createElement("style")
welcomeCss.type = 'text/css';
welcomeCss.appendChild(document.createTextNode(".welcome { justify-content : normal !important;}"));

document.getElementsByTagName('head')[0].appendChild(welcomeCss)

const Item = styled(Paper)(({ theme }) => {

    return ({
        backgroundColor: "transparent",
        ...theme.typography.body2,
        padding: 0,
        textAlign: 'center',
        boxShadow: theme.shadows[0],
        color: theme.palette.text.secondary,
    })
}
);


export default function MainContent(props) {
    const theme = useTheme();
    const dispatch = useDispatch();
    const { isTablet, isMobile } = useDevice();
    const isSideMenuOpen = (isMobileBrowser() || isIpad()) ? false : true;
    const [open, setOpen] = React.useState(isSideMenuOpen);

    React.useEffect(() => {
        if ((isTablet || isMobile) && open) {
            handleDrawerClose();
        } else if ((!isTablet && !isMobile) && !open) {
            handleDrawerOpen();
        }
    }, [isTablet, isMobile])

    const handleDrawerOpen = () => {
        setOpen(true);
        dispatch(setLeftMenuStatus(true));
    };

    const handleDrawerClose = () => {
        setOpen(false);
        dispatch(setLeftMenuStatus(false));
    };

    const {
        paymentPendingInvition
    } = useSelector(state => state[FEATURE_CUSTOM_PAYMENT])

    // const isMobile  =  useMediaQuery('(max-width:600px)');

    // we have set is false intentionally, when react-native app will get ready for live then enable this
    const _isSocialMobileApp = false; // isSocialMobileApp();

    return (
        <>
            <CssBaseline />
            {
                open && isTablet && <div className='custom-backdrop-dashboard'></div>
            }
            <AppBarMenu position="fixed" open={open}
                sx={{
                    backgroundColor: "var(--theme-primary-color)"
                }}
                className={open ? 'dash-toggle-open' : 'dash-toggle-close'}
            >
                <Toolbar>

                    <IconButton
                        id='open-menu'
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        edge="start"
                        size="medium"
                        sx={{ mr: 2, fontSize: "18px", ...(open && { display: 'none' }) }}
                    >
                        <i className="fa fa-bars fa-2x" aria-hidden="true"></i>
                        <NavBars />

                    </IconButton>
                    <Typography variant="h6" noWrap component="div"
                        sx={{
                            // marginLeft: "30px",
                            width: "100%"
                        }}
                    >
                        {getBaseConfig("sideBarTitle")}
                    </Typography>
                    {(isMobile || isTablet) && <div className='pull-left w-100 welcome-page-settings mr-0 menuWrapper1'>{!getBaseConfig("willAuthorize") &&
                        _isSocialMobileApp ? <></> : <>
                        <LanguageSelect />
                        <Avatar />
                    </>
                    }</div>}
                    <Box sx={{ flexGrow: 1 }} />
                    <Box sx={{ display: { xs: 'none', md: 'flex' } }}>

                        <div className="welcome-page-setting-container d-block d-flex justify-content-between">
                            {/* <div className='welcome-page-settings notification-bedge'>
                                <Tooltip
                                    title="View Invitations"
                                    arrow
                                >
                                    <Badge badgeContent={paymentPendingInvition || 10} color="success"
                                        onClick={() => dispatch(setPaymentSelectedPage(PaymentPages.INVITATION_LIST))} >

                                        <i className="fa fa-bell"
                                            style={{
                                                fontSize: "20px !important"
                                            }}
                                        ></i>
                                    </Badge>
                                </Tooltip>
                            </div> */}

                            <div className='welcome-page-settings ques'>
                                <div className="toolbox-button" onClick={() => {
                                    // this.startTutorial();
                                    // dispatch(setAvatarPop(false));
                                }}>
                                    <div className="toolbox-icon">
                                        {/* <img src={setupguide} /> */}
                                    </div>
                                </div>
                            </div>
                            {/* <div className='welcome-page-settings' onClick={() => dispatch(setAvatarPop(false))}>
                                <SettingsButton
                                    tooltipPosition="bottom"
                                    defaultTab={SETTINGS_TABS.CALENDAR} />
                                <div
                                    className='settings-toolbar-content' />
                            </div> */}


                            {(!isMobile && !isTablet) && <>
                                {_isSocialMobileApp ? <></> : <><div className='welcome-page-settings' style={{ width: "100%" }} >
                                    <LanguageSelect />
                                </div>
                                <div className="welcome-page-settings">
                                    {
                                        !getBaseConfig("willAuthorize") && <Avatar />
                                    }
                                    </div></>} </>}

                        </div>
                    </Box>
                </Toolbar>
            </AppBarMenu>

            <Drawer
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                    },
                }}
                variant="persistent"
                anchor="left"
                open={open}
            >

                <DrawerHeader>
                    <Grid item container>
                        <Grid item xs={10} md={10} lg={10} sm={10} textAlign={"center"} >
                            <Typography
                                align='center'
                            >
                                <span style={{
                                    fontSize: "22px",
                                    color: "#000"
                                }}>{getBaseConfig("sideBarTitle")}</span>
                            </Typography>
                        </Grid>
                        <Grid item xs={2} md={2} lg={2} sm={2} style={{ alignSelf: "center" }} >
                            <div id='close-menu' onClick={handleDrawerClose} style={{ alignSelf: "center", textAlign: "center" }}>
                                {theme.direction === 'ltr' ?
                                    <i className="fa fa-chevron-left cursor-pointer"
                                    ></i>
                                    : <i className="fa fa-chevron-right cursor-pointer"></i>}
                            </div>
                        </Grid>
                    </Grid>
                </DrawerHeader>
                <Divider />
                <SideBar handleDrawerClose={handleDrawerClose} />
            </Drawer>
        </>
    );
}
